import { Grid } from '@mui/material';
import { Box } from '@mui/system';
import MediumTypography from '../../components/formlib/MediumTypography';
import { ProgressNoteContact } from '../../utils/type';
import { useContext } from 'react';
import {
  LookUpContext,
  LookUpContextType,
} from '../../context/LookUpContextProvider';

interface SelectedContactsScreenType {
  multiSelectContact: ProgressNoteContact[];
}

const SelectedContacts = ({
  multiSelectContact,
}: SelectedContactsScreenType) => {
  const { lookups } = useContext(LookUpContext) as LookUpContextType;

  const getGuardianType = (guardianType: string): string => {
    if (lookups) {
      return (
        lookups?.guardianType?.find(
          (g) => g.code.toUpperCase() === guardianType.toUpperCase(),
        )?.description ?? '-'
      );
    }
    return '-';
  };
  return (
    <Grid container rowGap={2} alignItems={'center'} marginTop={2}>
      {multiSelectContact.map((contact) => {
        const prefixes = [
          contact.isPrimary && 'Primary',
          contact.isLegal && 'Legal',
        ].filter(Boolean);

        const displayName =
          contact.isGuardian && prefixes.length > 0
            ? `${contact.name} - (${prefixes.join(', ')})`
            : contact.name;
        return (
          <Grid item key={contact.contactId}>
            <Box
              sx={{
                display: 'inline-flex',
                padding: '6px',
                marginRight: '8px',
                borderRadius: '4px',
                alignItems: 'center',
                backgroundColor: '#E7F0F0',
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'baseline',
                  marginRight: '20px',
                }}
              >
                <MediumTypography
                  labelid="ProgressNote.Name"
                  defaultlabel="Name:"
                  textColor="#97A6A5"
                  sxProps={{
                    fontSize: '16px',
                  }}
                />

                <MediumTypography
                  sxProps={{
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    marginLeft: contact.name ? '4px' : '16px',
                  }}
                  textColor="#2A4241"
                  label={displayName}
                />
              </Box>

              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                }}
              >
                <MediumTypography
                  labelid="ProgressNote.RelationshipToChild"
                  defaultlabel="Guardian Type:"
                  textColor="#97A6A5"
                  sxProps={{
                    fontSize: '16px',
                  }}
                />

                <MediumTypography
                  sxProps={{
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    marginLeft: contact.relationshipToClient ? '4px' : '16px',
                  }}
                  textColor="#2A4241"
                  label={
                    contact.relationshipToClient
                      ? getGuardianType(contact.relationshipToClient)
                      : '-'
                  }
                />
              </Box>
            </Box>
          </Grid>
        );
      })}
    </Grid>
  );
};

export default SelectedContacts;
